import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import Chat from './common/Chat';
import { getFaqData } from '../assets/js/faqData';
import { agentAPIMap } from '../assets/js/constants';

export default function FAQ() {
  const { selectedAgent } = useOutletContext(); // <- now receives from Layout
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [openQuestions, setOpenQuestions] = useState({});
  const [showSearch, setShowSearch] = useState(false);

  const apiBaseUrl = agentAPIMap[selectedAgent];
  const [selectedText, setSelectedText] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [apiHistory, setApiHistory] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleResponse = (answer, question, extra = {}) => {
    setChatHistory((prev) => [...prev, { question, answer }]);
    if (extra.suggestions) setSuggestions(extra.suggestions);
    if (extra.chat_history) setApiHistory(extra.chat_history);
    setIsLoading(false);
  };

  const handleLoading = (val) => {
    setIsLoading(val);
  };

  // Dynamically load faqData when agent changes
  const faqData = useMemo(() => getFaqData(selectedAgent), [selectedAgent]);

  const handleToggle = (index) => {
    setOpenQuestions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
  };

  const filteredFaqs = faqData
    .filter(
      (section) =>
        activeCategory === 'all' || section.category === activeCategory
    )
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.answer.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((section) => section.items.length > 0);

  const categories = useMemo(() => {
    const allCats = faqData.map((section) => section.category);
    const uniqueCats = Array.from(new Set(allCats)).filter((cat) => cat !== 'all');
    return ['all', ...uniqueCats];
  }, [faqData]);


  return (
    <div className="faqdiv">
      {/* Header with title and toggle */}
      <div className="faq-header">
        <div className="faq-title-row">
          <div>
            <h1 className="title">Frequently Asked Questions</h1>
            <p>Find answers to common questions about our products and services</p>
          </div>

          <div className="search-box">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search questions..."
            />
            <button
              className="clear-search"
              title="Clear search"
              onClick={handleClearSearch}
            >
              <i className="fa-solid fa-times"></i>
            </button>
          </div>

          {/* Toggle between Tags and Search */}
          {/* {showSearch ? (
            <div className="search-box">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search questions..."
              />
              <button
                className="clear-search"
                title="Clear search"
                onClick={handleClearSearch}
              >
                <i className="fa-solid fa-times"></i>
              </button>
            </div>
          ) : (
            <div className="category-filter">
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`category-btn ${activeCategory === cat ? 'active' : ''}`}
                  onClick={() => handleCategoryClick(cat)}
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>
          )} */}

          {/* Toggle icon to switch between search and tags */}
          {/* <div className="faq-toggle-icons">
            {!showSearch ? (
              <i
                className="fa-solid fa-magnifying-glass toggle-icon"
                title="Search"
                onClick={() => setShowSearch(true)}
              ></i>
            ) : (
              <i
                className="fa-solid fa-tags toggle-icon"
                title="Tags"
                onClick={() => {
                  setShowSearch(false);
                  setSearchTerm('');
                }}
              ></i>
            )}
          </div> */}
        </div>
      </div>

      {/* FAQs */}
      <div className="faq-container">
        <div className="faq-content">
          {filteredFaqs.map((section, sIdx) => (
            <div key={sIdx} className="faq-category" data-category={section.category}>
              {/* <h2>{section.title}</h2> */}
              {section.items.map((item, iIdx) => {
                const index = `${section.category}-${iIdx}`;
                const isOpen = openQuestions[index];
                return (
                  <div key={iIdx} className="faq-item">
                    <div
                      className="faq-question"
                      onClick={() => handleToggle(index)}
                    >
                      <h3>{item.question}</h3>
                      <span className="faq-icon">
                        <i className={`fa-solid ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
                      </span>
                    </div>
                    {isOpen && (
                      <div className="faq-answer">
                        <p>{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
          {filteredFaqs.length === 0 && <p>No questions match your search.</p>}
        </div>
        
        <Chat
          selectedText={selectedText}
          onResponse={handleResponse}
          onLoading={handleLoading}
          apiBaseUrl={apiBaseUrl}
        />

      </div>
    </div>
  );
}